/**
 * Better Auth — client-side bindings.
 *
 * Use these hooks/functions from any React component:
 *   const { data: session, isPending } = useSession()
 *   await signIn.email({ email, password })
 *   await signUp.email({ email, password, name })
 *   await signOut()
 */

import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  // Same-origin; Better Auth derives the base URL from window.location.
  // For server-rendered pages it falls back to the env var.
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
})

export const { useSession, signIn, signUp, signOut, getSession } = authClient
